import type { SVGProps } from 'react';

/**
 * The one4two signet — four triangles reading as the "4" between the two ones.
 * Paints via `currentColor`, so it inherits the surrounding text colour and
 * follows the aperture mode without a second asset.
 *
 * The nested transforms come from the source artwork verbatim; the clip path it
 * carried was exactly the paths' bounding box, so dropping it changes nothing
 * and avoids a duplicate element id when the logo renders more than once.
 *
 * The four triangles carry the shared `logo__tri` parts, which is what lets the
 * header animate this mark and the vertical lockup with one set of rules — see
 * `styles/components/logo.css`. Classes rather than the artwork's ids, so two
 * marks on a page cannot collide.
 */
export function LogoSignet(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 67 58" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g transform="matrix(1,0,0,1,-390.695,-719.12)">
                <g transform="matrix(0.236576,0,0,0.26914,394.625,722.695)">
                    <g transform="matrix(2.782,0,0,2.44539,-217.752,-13.2519)">
                        <path
                            className="logo__tri logo__tri--top"
                            d="M146.9,41.1L123.1,0L99.4,41.1L146.9,41.1Z"
                            fillRule="nonzero"
                        />
                        <path
                            className="logo__tri logo__tri--left"
                            d="M96,46.9L119.8,88.1L72.3,88.1L96,46.9Z"
                            fillRule="nonzero"
                        />
                        <path
                            className="logo__tri logo__tri--right"
                            d="M150.3,46.9L174.1,88.1L126.6,88.1L150.3,46.9Z"
                            fillRule="nonzero"
                        />
                        <path
                            className="logo__tri logo__tri--middle"
                            d="M123.2,88.1L97.8,44.1L148.6,44.1L123.2,88.1Z"
                            fillRule="nonzero"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
